export const accountActivitySelector = state =>
  state.balanceSheetManagement.shared.accountActivity.accountActivityCollection;

export const accountActivityLoadingSelector = state =>
  state.balanceSheetManagement.shared.accountActivity.accountActivityLoading;
